import React, { useEffect, useState, useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { mutation, validationSchema, defaultValues, handleSubmit, EditContractForm } from "./forms/edit-form";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { getEntityWithoutTypename } from "pages/utils";
import { useQuery } from "components/graphql/query/use-query";
import { getContractQuery } from "./details-page";
import { QueryResponseHandler } from "components/graphql";

const ContractEditPage = ({
  intl,
  history,
  match: {
    params: { id },
  },
}) => {
  const [updateContract] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  const query = useMemo(() => getContractQuery(id), [id]);
  const { data, loading, error } = useQuery(query);

  const [initialValues, setInitialValues] = useState(defaultValues);
  const contractToEdit = data ? data.contract : null;

  useEffect(
    () => {
      if (contractToEdit) {
        const value = getEntityWithoutTypename(contractToEdit);
        setInitialValues({
          ownedByPartnerId: value.ownedByPartnerId,
          name: value.name,
          description: value.description,
          deploymentId: value.deploymentId,
          liveCommentatorSupport: value.liveCommentatorSupport,
          keepVideosForMonths: value.keepVideosForMonths,
          allowedMasterStreamSave: value.allowedMasterStreamSave,
          monthlyTiiviiHours: value.monthlyTiiviiHours,
          allowedProductionTypes: value.allowedProductionTypes && value.allowedProductionTypes.map(type => type.id),
          allowedEventTypes: value.allowedEventTypes && value.allowedEventTypes.map(type => type.id),
          tiiviiOttConfig: {
            enabled: !!value.tiiviiOttConfig?.enabled,
            webhookUrl: value.tiiviiOttConfig?.webhookUrl,
            nimbleConfigUrl: value.tiiviiOttConfig?.nimbleConfigUrl
          }
        });
      }
    },
    [contractToEdit],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={contractToEdit}>
        <PageHeaderBar title="app.page.contract.edit" />
        <PageSection>
          <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema(intl)}
            onSubmit={handleSubmit({
              updateContract,
              history,
              customerId: currentCustomerId,
              contractId: id,
            })}
          >
            {props => (
              <DataGrid>
                <EditContractForm {...props} />
              </DataGrid>
            )}
          </ValidatedForm>
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default ContractEditPage;
